export const environment = {
  apiUrl: 'https://logistica-api-hml.unimedinconfidentes.coop.br/v1',
  sgiUrl: 'https://sgi-hml.unimedinconfidentes.coop.br',
  sgiApiUrl: 'https://sgi-api-hml.unimedinconfidentes.coop.br/v1',
  production: false,
  environment: 'development',
  aplicacaoId: '822bf40d-2a5b-44a4-90a2-f5bbd6054caa',
};